import { DrawerDialog, DrawerDialogProps } from '@/common/components/drawer-dialog';
import { discoverPagesLoaderData } from '@/pages/discover/loader/discover-pages-loader';
import { getDynamicCurrency } from '@/util-conversion/currency/currency-to-string';
import { LoaderFunction } from 'react-router';

export const loader: LoaderFunction = () => {
  return discoverPagesLoaderData();
};
export interface SavingsCalculatorV2UpfrontCostInfoDrawerDialogProps
  extends DrawerDialogProps {
  flexcarMembershipCost?: number;
  flexcarShippingCost?: number;
  flexcarNewCarSurcharge?: number;
}

export default function SavingsCalculatorV2UpfrontCostInfoDrawerDialog({
  open,
  handleClose,
  flexcarShippingCost,
  flexcarNewCarSurcharge,
  flexcarMembershipCost,
}: SavingsCalculatorV2UpfrontCostInfoDrawerDialogProps) {
  return (
    <DrawerDialog open={open} handleClose={handleClose} title="Flexcar Upfront Cost">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <div className="body-strong">Membership Fee</div>
          <div className="body">
            Your annual membership fee of{' '}
            {getDynamicCurrency(flexcarMembershipCost ? flexcarMembershipCost : 249)}{' '}
            covers maintenance and roadside assistance. If you&apos;re not fully satisfied
            with your Flexcar, return it within the first two weeks, and the membership
            fee won&apos;t be charged.
          </div>
        </div>
        {flexcarShippingCost && flexcarShippingCost > 0 ? (
          <div className="flex flex-col gap-2">
            <div className="body-strong">Shipping Fee</div>
            <div className="body">
              This one time shipping fee of {getDynamicCurrency(flexcarShippingCost)}{' '}
              covers the cost of shipping the vehicle to your closest Flexcar location.
            </div>
          </div>
        ) : null}
        {flexcarNewCarSurcharge && flexcarNewCarSurcharge > 0 ? (
          <div className="flex flex-col gap-2">
            <div className="body-strong">New Car Surcharge</div>
            <div className="body">
              For a one-time {getDynamicCurrency(flexcarNewCarSurcharge)} surcharge, enjoy
              a brand-new car.
            </div>
          </div>
        ) : null}
      </div>
    </DrawerDialog>
  );
}
